import React from "react";

import { Box, Paper, Stack, Typography, Container } from "@mui/material";

type Props = {
  color: string;
  text: string;
  number: string;
  icon: React.ReactNode;
  onClick: () => void;
};

export const Card: React.FC<Props> = ({
  color,
  text,
  number,
  icon,
  onClick,
}) => {
  return (
    <Box
      style={{
        height: "200px",
        display: "flex",
        alignItems: "center",
        width: "100%",
      }}
      onClick={() => {
        onClick();
      }}
    >
      <Paper sx={{ height: "100px", width: "100%" }}>
        <Stack
          direction="row"
          sx={{
            mx: "10px",
          }}
        >
          <Container
            sx={{ position: "relative", width: "100%", height: "100px" }}
          >
            <Paper
              elevation={3}
              sx={{
                padding: "30px",
                backgroundColor: `${color}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "absolute",
                top: "-40px",
              }}
            >
              {icon}
            </Paper>
          </Container>
          <Container
            sx={{ height: "100px", display: "flex", alignItems: "center" }}
          >
            <Typography color={`${color}`} fontWeight="bold">
              {text}
            </Typography>
          </Container>
          {/* <Container
            sx={{ height: "100px", display: "flex", alignItems: "center" }}
          >
            <Typography
              color={color}
              fontWeight="bold"
              fontSize="40px"
              sx={{ width: "100%", textAlign: "right" }}
            >
              {number}
            </Typography>
          </Container> */}
        </Stack>
      </Paper>
    </Box>
  );
};
